import React from "react";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import { ShimmerWrapper } from "./_styles/ShimmerWrapper";

const ShimmerPage = () => {
  return (
    <>
      <>
        <ShimmerWrapper className="first-child">
          <ShimmerPlaceholder visible={true} height="4em" />
          <form className="basic-form">
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={true} />
            </div>
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={true} />
            </div>
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={true} />
            </div>
            <div className="basic-form-input ">
              <ShimmerPlaceholder visible={true} />
            </div>
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={true} />
            </div>
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={true} />
            </div>
            <div className="basic-form-input basic-form-input-small">
              <ShimmerPlaceholder visible={true} />
            </div>
            <div className="basic-form-input basic-form-input-small">
              <ShimmerPlaceholder visible={true} />
            </div>
            <ShimmerPlaceholder visible={true} height="4em" />
            <ShimmerPlaceholder visible={true} height="2.5em" width="7em" />
          </form>
        </ShimmerWrapper>
      </>
    </>
  );
};

export default ShimmerPage;
